import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'

import { registerLicense, loadCldr, L10n } from '@syncfusion/ej2-base'
import { register as registerSwiperElements } from 'swiper/element/bundle'

// Import Arabic CLDR data for Syncfusion components
import * as arNumbers from '@syncfusion/ej2-cldr-data/main/ar/numbers.json'
import * as arTimeZoneNames from '@syncfusion/ej2-cldr-data/main/ar/timeZoneNames.json'
import * as arGregorian from '@syncfusion/ej2-cldr-data/main/ar/ca-gregorian.json'
import * as numberingSystems from '@syncfusion/ej2-cldr-data/supplemental/numberingSystems.json'

// Load CLDR data for Arabic locale
loadCldr(arNumbers, arTimeZoneNames, arGregorian, numberingSystems)

// Load Arabic translations for Syncfusion Schedule component
L10n.load({
    ar: {
        schedule: {
            day: 'يوم',
            week: 'أسبوع',
            workWeek: 'أسبوع العمل',
            month: 'شهر',
            agenda: 'أجندة',
            today: 'اليوم',
            noEvents: 'لا توجد أحداث',
            emptyContainer: 'لا توجد أحداث مجدولة لهذا اليوم',
            allDay: 'طوال اليوم',
            start: 'بداية',
            end: 'نهاية',
            more: 'المزيد',
            close: 'إغلاق',
            cancel: 'إلغاء',
            noTitle: '(بدون عنوان)',
            delete: 'حذف',
            deleteEvent: 'حذف الحدث',
            deleteMultipleEvent: 'حذف أحداث متعددة',
            selectedItems: 'العناصر المحددة',
            deleteSeries: 'حذف السلسلة',
            edit: 'تعديل',
            editSeries: 'تعديل السلسلة',
            editEvent: 'تعديل الحدث',
            createEvent: 'إنشاء',
            subject: 'الموضوع',
            addTitle: 'إضافة عنوان',
            moreDetails: 'المزيد من التفاصيل',
            save: 'حفظ',
            editContent: 'هل تريد تعديل هذا الحدث فقط أو السلسلة بأكملها؟',
            deleteContent: 'هل أنت متأكد من حذف هذا الحدث؟',
            deleteMultipleContent: 'هل أنت متأكد من حذف الأحداث المحددة؟',
            newEvent: 'حدث جديد',
            title: 'العنوان',
            location: 'الموقع',
            description: 'الوصف',
            timezone: 'المنطقة الزمنية',
            startTimezone: 'منطقة البداية الزمنية',
            endTimezone: 'منطقة النهاية الزمنية',
            repeat: 'تكرار',
            saveButton: 'حفظ',
            cancelButton: 'إلغاء',
            deleteButton: 'حذف',
            recurrence: 'التكرار',
            wrongPattern: 'نمط التكرار غير صالح',
            seriesChangeAlert:
                'هل تريد إلغاء التغييرات التي تم إجراؤها على مثيلات محددة من هذه السلسلة وربطها مرة أخرى بالسلسلة بأكملها؟',
            createError:
                'يجب أن تكون مدة الحدث أقصر من تكرار حدوثه. قلل المدة، أو غير نمط التكرار في محرر أحداث التكرار.',
            sameDayAlert:
                'لا يمكن أن يحدث حدثان من نفس الحدث في نفس اليوم',
            editRecurrence: 'تعديل التكرار',
            repeats: 'يتكرر',
            alert: 'تنبيه',
            startEndError: 'تاريخ النهاية المحدد يحدث قبل تاريخ البداية',
            invalidDateError: 'قيمة التاريخ المدخلة غير صالحة',
            blockAlert: 'لا يمكن جدولة الأحداث ضمن النطاق الزمني المحظور',
            ok: 'موافق',
            yes: 'نعم',
            no: 'لا',
            occurrence: 'حدوث',
            series: 'سلسلة',
            previous: 'السابق',
            next: 'التالي',
            timelineDay: 'يوم الجدول الزمني',
            timelineWeek: 'أسبوع الجدول الزمني',
            timelineWorkWeek: 'أسبوع عمل الجدول الزمني',
            timelineMonth: 'شهر الجدول الزمني',
            timelineYear: 'سنة الجدول الزمني',
            editFollowingEvent: 'الأحداث التالية',
            deleteTitle: 'حذف الحدث',
            editTitle: 'تعديل الحدث',
            beginFrom: 'يبدأ من',
            endAt: 'ينتهي في',
            expandAllDaySection: 'توسيع',
            collapseAllDaySection: 'طي'
        }
    }
})

// registerLicense(
//     'Ngo9BigBOggjHTQxAR8/V1NNaF1cWWhPYVF1WmFZfVtgcF9DZVZQQWY/P1ZhSXxWdkBhXX5YdXZURmRVWE19XUs=' // Replace with your actual Syncfusion license key
// )

registerSwiperElements()

platformBrowserDynamic()
    .bootstrapModule(AppModule, {
        ngZoneEventCoalescing: true
    })
    .catch((err) => console.error(err))
